import { getApiBaseUrl } from '../utils/config';

export interface AdData {
  id: string;
  storeId: string;
  advertiserName: string;
  imageUrl: string;
  linkUrl: string | null;
}

/**
 * 현재 활성 광고 조회
 */
export async function getActiveAd(storeId: string): Promise<AdData | null> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/stores/${encodeURIComponent(storeId)}/ad`;

  try {
    const response = await fetch(url);
    const json = await response.json();

    if (!response.ok || !json.success || !json.data) {
      return null;
    }

    return json.data as AdData;
  } catch {
    return null;
  }
}

/**
 * 노출 기록
 */
export async function recordImpression(adId: string): Promise<void> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/ads/${encodeURIComponent(adId)}/impression`;

  try {
    await fetch(url, { method: 'POST' });
  } catch {
    // 노출 기록 실패는 무시
  }
}

/**
 * 클릭 기록
 */
export async function recordClick(adId: string): Promise<void> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/ads/${encodeURIComponent(adId)}/click`;

  try {
    await fetch(url, { method: 'POST' });
  } catch {
    // 클릭 기록 실패는 무시
  }
}
